<template>
  <div class="powerful_code-main">
    <div class="page-app active">
      <div class="page-phone" style="background: rgb(255, 255, 255)">
        <div class="page-render page">
          <!-- 加载状态 -->
          <div v-if="loading" class="loading">加载中...</div>

          <!-- 错误状态 -->
          <div v-else-if="error" class="error">{{ error }}</div>

          <!-- 内容展示 -->
          <template v-else>
            <!-- 动态内容区域 -->
            <div v-for="(item, index) in contentItems" :key="index" class="content-item">
              <!-- 文字内容 -->
              <div v-if="item.type === 'text'" class="rich-text-box-wrapper">
                <button 
                  class="copy-text-btn"
                  :class="{ 'copied': copiedTextBlocks[index] }"
                  @click="copyTextContent(index, item)"
                  title="复制文字内容"
                >
                  点击复制
                </button>
                <div
                  class="editor-content-view"
                  v-html="convertUrlsInHtml(item.content)"
                  :style="{
                    fontSize: item.style.fontSize || '16px',
                    fontWeight: item.style.fontWeight || 'normal',
                    fontStyle: item.style.fontStyle || 'normal',
                    textDecoration: item.style.textDecoration || 'none',
                    color: item.style.color || '#000000',
                    textAlign: item.style.textAlign || 'left',
                    lineHeight: item.style.lineHeight ? String(item.style.lineHeight) : '1.5',
                    padding: '15px',
                    border: '2px dashed #ddd',
                    outline: 'none',
                    margin: item.style.margin || '15px 0'
                  }"
                ></div>
              </div>

              <!-- 图片内容 -->
              <div v-if="item.type === 'image'" class="banner-img">
                <img
                  :src="item.src"
                  :alt="item.alt"
                  :style="{
                    border: item.style.border || '',
                    width: item.style.width || '100%',
                    display: 'block'
                  }"
                />
              </div>

              <!-- 按钮内容 -->
              <div v-if="item.type === 'button'">
                <button
                  class="coppy_button"
                  :style="{
                    background: item.style.background || 'linear-gradient(90deg, rgb(251, 136, 77) 0%, rgb(247, 62, 40) 100%)',
                    color: item.style.color || '#ffffff',
                    width: item.style.width || '100%',
                    height: item.style.height || '50px',
                    borderRadius: item.style.borderRadius || '3px',
                    border: item.style.border || 'none',
                    fontSize: item.style.fontSize || '16px',
                    fontWeight: item.style.fontWeight || 'bold',
                    marginTop: item.style.marginTop || '0px',
                    cursor: item.style.cursor || 'pointer'
                  }"
                  @click="handleButtonClick(item)"
                >
                  {{ item.text }}
                </button>
              </div>

              <!-- 链接内容 -->
              <div v-if="item.type === 'link'" class="link_box">
                <a
                  :href="item.url"
                  target="_blank"
                  :style="{
                    color: item.style.color || '#0066cc',
                    textDecoration: item.style.textDecoration ? 'underline' : 'none',
                  }"
                >
                  {{ item.text && item.text.trim() ? item.text : item.url }}
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { get } from "@/utils/request";
import { ElMessage } from "element-plus";
import clipboard3 from "vue-clipboard3";

export default defineComponent({
  name: "ContentDisplayPage",
  data() {
    return {
      loading: true,
      error: null,
      contentItems: [],
      title: '',
      key: null,
      copiedTextBlocks: {}, // 记录每个文字块的复制状态
      cacheKey: '',
      cacheTTL: 5 * 60 * 1000 // 5 分钟缓存
    };
  },
  created() {
    this.extractKeyFromUrl();
    if (this.key) {
      this.cacheKey = `activity-content-${this.key}`;
      if (!this.restoreFromCache()) {
        this.fetchContent();
      } else {
        this.loading = false;
      }
    }
  },
  watch: {
    title(newTitle) {
      document.title = newTitle ? String(newTitle) : '鲁❶豆群';
    }
  },
  methods: {
    extractKeyFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      this.key = urlParams.get('key');
      if (!this.key) {
        this.error = "URL中未找到key参数";
        this.loading = false;
        this.title = '参数错误';
      }
    },
    async fetchContent() {
      try {
        const response = await get(`/kafuFour/jdUrl/lu1dou/get?key=${this.key}`);
        if (response && response.items) {
          this.contentItems = response.items;
          console.log(response);
          this.title = response.title;
          this.saveToCache({
            contentItems: response.items,
            title: response.title
          });
        } else {
          this.error = "未找到对应内容";
          this.title = '未找到内容';
        }
      } catch (err) {
        console.error("获取内容失败:", err);
        this.error = "加载内容失败，请稍后重试";
        this.title = '加载失败';
      } finally {
        this.loading = false;
      }
    },
    // 处理HTML内容中的URL转换（保留原始结构）
    convertUrlsInHtml(html) {
      if (!html) return html;

      try {
        // 创建一个临时div来解析HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // 遍历所有文本节点
        const walker = document.createTreeWalker(
          tempDiv,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );

        let node;
        const replacements = [];

        // 先收集需要替换的节点
        while (node = walker.nextNode()) {
          if (node.parentNode.nodeName !== 'A' && node.nodeValue.trim()) {
            const text = node.nodeValue;
            const urlRegex = /(https?:\/\/[^\s]+)/g;
            let match;
            let lastIndex = 0;
            let hasUrls = false;
            let newHtml = '';

            while ((match = urlRegex.exec(text)) !== null) {
              hasUrls = true;
              newHtml += text.substring(lastIndex, match.index);
              newHtml += `<a href="${match[0]}" target="_blank" style="color: #0066cc; text-decoration: underline;">${match[0]}</a>`;
              lastIndex = urlRegex.lastIndex;
            }

            if (hasUrls) {
              newHtml += text.substring(lastIndex);
              replacements.push({ node, html: newHtml });
            }
          }
        }

        // 执行替换（反向以避免影响walker）
        for (let i = replacements.length - 1; i >= 0; i--) {
          const { node, html } = replacements[i];
          const newSpan = document.createElement('span');
          newSpan.innerHTML = html;
          node.parentNode.replaceChild(newSpan, node);
        }

        return tempDiv.innerHTML;
      } catch (e) {
        console.error("URL转换出错，返回原始内容:", e);
        return html;
      }
    },

    async handleButtonClick(item) {
      if (item.type === "button" && item.link) {
        try {
          const { toClipboard } = clipboard3();
          const textToCopy = item.text ? `${item.text}\n${item.link}` : item.link;
          await toClipboard(textToCopy);

          let alertMessage = "一键复制 打开京東app查看";
          const urls = item.link.match(/http.+?\s/);

          if (urls && urls.length >= 0 && urls[0].includes("tb.cn")) {
            alertMessage = "一键复制 打开淘宝app查看";
          }

          ElMessage({
            message: `<span style="--el-message-text-color: #f5f5f5; color:#f5f5f5;">${alertMessage}<span>`,
            type: "success",
            customClass: "msgInfo",
            dangerouslyUseHTMLString: true,
          });

          if (this.isMobile() && urls && urls.length >= 0 && urls[0].includes("m.tb.cn")) {
            location.href = urls[0]
              .replace("m.tb.cn", "s.tb.cn")
              .replace(/\s/g, "");
          } else if (this.isMobile()) {
            window.open(item.link, "_blank");
          }
        } catch (error) {
          console.error("复制失败:", error);
          window.open(item.link, "_blank");
        }
      }
    },
    isMobile() {
      const userAgent = navigator.userAgent;
      const mobileKeywords = [
        "Mobile",
        "Android",
        "iPhone",
        "iPad",
        "Windows Phone",
      ];
      return mobileKeywords.some((keyword) => userAgent.includes(keyword));
    },
    restoreFromCache() {
      if (!this.cacheKey) return false;
      try {
        const cached = sessionStorage.getItem(this.cacheKey);
        if (!cached) return false;

        const parsed = JSON.parse(cached);
        if (!parsed || !parsed.timestamp) {
          sessionStorage.removeItem(this.cacheKey);
          return false;
        }

        if (Date.now() - parsed.timestamp > this.cacheTTL) {
          sessionStorage.removeItem(this.cacheKey);
          return false;
        }

        this.contentItems = parsed.contentItems || [];
        this.title = parsed.title || '';
        return true;
      } catch (error) {
        console.error('读取缓存失败:', error);
        sessionStorage.removeItem(this.cacheKey);
        return false;
      }
    },
    saveToCache(payload) {
      if (!this.cacheKey) return;
      try {
        const cacheData = {
          timestamp: Date.now(),
          contentItems: payload.contentItems || [],
          title: payload.title || ''
        };
        sessionStorage.setItem(this.cacheKey, JSON.stringify(cacheData));
      } catch (error) {
        console.error('写入缓存失败:', error);
      }
    },
    // 复制文字块内容
    async copyTextContent(index, item) {
      try {
        const { toClipboard } = clipboard3();
        // 创建临时div来提取纯文本
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = item.content;
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        
        await toClipboard(textContent);
        
        // 标记为已复制
        this.copiedTextBlocks[index] = true;
        
        ElMessage.success('文字内容已复制');
      } catch (error) {
        console.error("复制失败:", error);
        ElMessage.error('复制失败，请重试');
      }
    }
  }
});
</script>

<style scoped>
/* 原始样式完全保持不变 */
.powerful_code-main {
  max-width: 750px;
  margin: auto;
  box-shadow: 0 0 10px 10px #f5f5f5;
  min-height: 100vh;
}

html,
body {
  font-size: 14px;
  line-height: 1.15;
}

* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}

.page-app {
  display: block;
  border: none;
  outline: 1px solid #e8e8e8;
  box-sizing: border-box;
  background: white;
}

.page-app.active {
  display: flex;
  flex-direction: column;
}

.page-render {
  box-sizing: border-box;
  padding: 10px;
  height: 100%;
  display: block;
}

.page-phone {
  background: rgb(255, 255, 255);
}

.content-item {
  position: relative;
  margin: 0 0 15px 0;
}

.rich-text-box-wrapper {
  position: relative;
}

.copy-text-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  background: none;
  color: #1E90FF;
  border: none;
  cursor: pointer;
  font-size: 14px;
  z-index: 10;
  transition: color 0.3s ease;
  font-weight: normal;
}

.copy-text-btn:hover {
  color: #0066CC;
}

.copy-text-btn.copied {
  color: #666666;
}

.copy-text-btn.copied:hover {
  color: #999999;
}

.banner-img {
  margin: 0 0;
}

.banner-img img {
  width: 100%;
  display: block;
}

.editor-content-view {
  outline: none;
}

.coppy_button {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 3px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  background: linear-gradient(90deg, rgb(251, 136, 77) 0%, rgb(247, 62, 40) 100%);
  color: white;
}

.link_box {
  margin-bottom: 10px;
}

.loading, .error {
  text-align: center;
  padding: 40px;
  font-size: 18px;
}

.error {
  color: #f56c6c;
}

/* 确保文本内容的样式一致 */
.editor-content-view >>> p {
  margin: 15px 0px;
  padding: 0px;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  outline: none;
  line-height: 1.5;
  color: rgb(51, 51, 51);
  font-family: "Times New Roman";
  font-size: 14px;
  text-align: center;
  white-space-collapse: preserve;
  background-color: rgb(255, 255, 255);
}

.editor-content-view >>> span {
  margin: 0px;
  padding: 0px;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  outline: none;
}

.editor-content-view >>> strong {
  font-weight: bolder;
}

.editor-content-view >>> em {
  font-style: italic;
}

.editor-content-view >>> u {
  text-decoration: underline;
}

/* 新增链接样式 */
.editor-content-view >>> a {
  color: #0066cc;
  text-decoration: underline;
  word-break: break-all;
}

/* 确保不破坏原始链接样式 */
.editor-content-view >>> a[href^="http"] {
  color: #0066cc !important;
  text-decoration: underline !important;
}
</style>
